
import Entity from '../entity'
import Address from '../address'
import Tpl from '../tpls/tplForSelect'

export default class CustomerDetail extends Entity<number>{
    code:string;
    name: string;
    addressId:number;
    phone:string;
    taxNumber: string;
    type: string;
    receiver: string;
    customerAddress: Address=new Address();
    typeName:string;
    clientName:string;
    fullAddress:string;
    creatorUserName:string;
    tpls: Array<Tpl>;
    defaultTPLCode:string;
}